var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entity
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            ref: "sectionHeader",
            attrs: {
              title: `Customer ${_vm.$route.meta.title}`,
              "show-toggle": true,
              "show-new": false,
              "show-print": _vm.entity && !_vm.entity.isNew,
              "show-delete":
                _vm.entity && _vm.entity.active && !_vm.entity.isNew,
              "menu-code-name": _vm.menuCodeName,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _vm.entity
                  ? _c("customer-side-menu", {
                      ref: "sideMenu",
                      attrs: {
                        "entity-name": _vm.entityName,
                        "is-person": _vm.entity.isPerson,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("router-view", {
                  attrs: { entity: _vm.entity, vehicles: _vm.vehicles },
                  on: {
                    entityDelete: function ($event) {
                      return _vm.onEntityDelete()
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "unsaved-modal",
            {
              attrs: { active: _vm.isUnsavedModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isUnsavedModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                skipSave: function ($event) {
                  return _vm.skipSave()
                },
                saveContinue: function ($event) {
                  return _vm.saveContinue()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Unsaved Changes"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "There are unsaved changes. Please select action below"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "save-conflict-modal",
            {
              attrs: { active: _vm.isSaveConflictModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isSaveConflictModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                reload: function ($event) {
                  return _vm.reloadData()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Change conflict"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "The data on the server is newer than the local copy. Please reload local data."
                  ),
                ]
              ),
            ]
          ),
          _vm.entity
            ? _c(
                "confirm-modal",
                {
                  attrs: {
                    active: _vm.isConfirmModalActive,
                    "ok-text": "Yes",
                    "cancel-text": "No",
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isConfirmModalActive = $event
                    },
                    ok: function ($event) {
                      return _vm.deleteEntity(false, false, _vm.deleteAndSave)
                    },
                    cancel: function ($event) {
                      return _vm.deleteEntity(false, true, false)
                    },
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Customer is in use")]
                  ),
                  _c(
                    "p",
                    { attrs: { slot: "text-content" }, slot: "text-content" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "has-text-primary has-text-weight-bold",
                        },
                        [_vm._v(_vm._s(_vm.entityName))]
                      ),
                      _vm._v(" is in use. Set to "),
                      _c("span", { staticClass: "tag is-danger" }, [
                        _vm._v("In-Active"),
                      ]),
                      _vm._v(" anyway? "),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }